import { HeroFuturistic } from '@/components/ui/hero-futuristic'
import { ServicesCalculator } from '@/components/ui/services-calculator'
import { PortfolioSection } from '@/components/ui/portfolio'
import { TestimonialsSection } from '@/components/ui/testimonials'
import { ProcessSection } from '@/components/ui/process'
import { FaqSection } from '@/components/ui/faq'
import { SectionDivider } from '@/components/ui/SectionDivider'

/** The one-pager (`/`) — everything that used to live directly in App.tsx before Phase 5 added routed pages. */
export function HomePage() {
  return (
    <main id="top">
      {/* Skip-link target — tabIndex={-1} so keyboard focus actually lands
          here on activation (id="top" on <main> stays for the existing
          nav/hash-scroll anchor, separate concern from the a11y skip link). */}
      <div id="main-content" tabIndex={-1} />
      <HeroFuturistic />
      <ServicesCalculator />
      <SectionDivider />
      <PortfolioSection />
      <SectionDivider />
      <TestimonialsSection />
      <ProcessSection />
      <SectionDivider />
      <FaqSection />
    </main>
  )
}
